import React, { useMemo } from 'react'
import { connect } from 'react-redux'

import { homeProductsSelector } from 'store/selectors/home'
import { bankNameSelector } from 'store/selectors/bank'

import useValidateProductsFlags from 'hooks/useValidateProductsFlags'

import StringFormat from 'utils/StringFormat'

import ProductsSlider from '../ProductSlider'
import ProductContainer from '../ProductContainer'

import { Container } from './ProductsList.style'
import { TitleMobileOnly } from '../ProductsContent/ProductsContent.style'

const podAndTudo = ['TUDO', 'POD']

const ProductListItem = ({ products, main, bankName }) => {
    const productsEnabled = useValidateProductsFlags(
        products,
        StringFormat.bankAbbreviation(bankName)
    )

    const productsToCarousel = useMemo(
        () =>
            productsEnabled.filter(
                (product) => !podAndTudo.includes(product.productType)
            ),
        [productsEnabled]
    )

    const flexibleProducts = useMemo(
        () =>
            productsEnabled
                .filter(() => main)
                .filter((product) => podAndTudo.includes(product.productType)),
        [productsEnabled, main]
    )

    return (
        <Container>
            {flexibleProducts.map((p) => (
                <ProductContainer
                    key={p.productType}
                    type={p.productType}
                    data={p}
                />
            ))}
            {flexibleProducts.length > 0 && (
                <TitleMobileOnly>
                    <span>
                        Ofereça aos seus colaboradores beneficios
                        <br />
                        <strong>em cartões com saldo único</strong>
                    </span>
                </TitleMobileOnly>
            )}
            <ProductsSlider products={productsToCarousel} />
        </Container>
    )
}

const mapStateToProps = (state) => ({
    products: homeProductsSelector(state),
    bankName: bankNameSelector(state)
})

export default connect(mapStateToProps)(ProductListItem)
